// styles
import styled from 'styled-components';
import { zIndexses } from 'utils/style';
// components
import ActionsMenu from './ActionsMenu';

export default styled(ActionsMenu)`
  position: absolute;
  box-shadow: 0px 1px 6px 0px rgba(0, 0, 0, 0.27);
  background-color: var(--white);
  border-radius: 4px;
  border: solid 1px var(--grey-mouse);
  right: 12px;
  top: 23px;
  min-width: 280px;
  max-width: 350px;
  z-index: ${zIndexses.actionsMenu};
  list-style: none;
  padding: 0;
  font-size: 16px;
  line-height: 24px;
`;
